/**
 * @generated SignedSource<<5ef9402c73f23c9364a39a7b37d38f8f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type LibraryHooksUseOpenChannelsModal_viewer$data = {
  readonly account: {
    readonly billingAccount: {
      readonly canCreateChannels: boolean;
    };
  };
  readonly " $fragmentType": "LibraryHooksUseOpenChannelsModal_viewer";
};
export type LibraryHooksUseOpenChannelsModal_viewer$key = {
  readonly " $data"?: LibraryHooksUseOpenChannelsModal_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"LibraryHooksUseOpenChannelsModal_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "LibraryHooksUseOpenChannelsModal_viewer",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Account",
      "kind": "LinkedField",
      "name": "account",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "BillingAccount",
          "kind": "LinkedField",
          "name": "billingAccount",
          "plural": false,
          "selections": [
            {
              "alias": "canCreateChannels",
              "args": [
                {
                  "kind": "Literal",
                  "name": "feature",
                  "value": "channels"
                }
              ],
              "kind": "ScalarField",
              "name": "hasAccessToFeature",
              "storageKey": "hasAccessToFeature(feature:\"channels\")"
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "e4a0b35aba620be8ae5821c6f72da83a";

export default node;
